import React from "react";
import styled from "styled-components";

const TalentCard = ({
  name,
  expertise,
  description,
  location,
  action,
  isSelected,
}) => {
  return (
    <Card
      className="pointer"
      isSelected={isSelected}
      onClick={action ? () => action() : null}
    >
      <CardHeader>
        <TalentName>{name}</TalentName>
        <Expertise>{expertise}</Expertise>
      </CardHeader>
      <CardBody>
        <Description>{description}</Description>
        <Location>
          <span role="img" aria-label="location">
            📍
          </span>
          {location}
        </Location>
      </CardBody>
    </Card>
  );
};

export default TalentCard;

const Card = styled.div`
  background-color: ${(props) => (props.isSelected ? "#d4edda" : "#fff")};
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.2s ease-in-out;
  &:hover {
    transform: translateY(-5px);
  }
`;

const CardHeader = styled.div`
  background-color: #f4f4f4;
  padding: 15px;
  border-bottom: 1px solid #e0e0e0;
`;

const TalentName = styled.h2`
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin: 0;
`;

const Expertise = styled.p`
  font-size: 14px;
  color: #666;
  margin: 5px 0 0 0;
`;

const CardBody = styled.div`
  padding: 15px;
`;

const Description = styled.p`
  font-size: 14px;
  color: #555;
  margin: 10px 0;
`;

const Location = styled.div`
  font-size: 14px;
  color: #888;
  display: flex;
  align-items: center;

  span {
    margin-right: 5px;
  }
`;
